import React from 'react';
import { Logo, LogoProps } from './Logo';

const LogoStacked = (props: LogoProps) => <Logo {...props} titleId="blackboard-logo-stacked" />;

export default LogoStacked;
